<template>
  <div class="rate-container">
    <p class="rating-tips">{{ $t('hm.label.rating.ratingTips') }}</p>
    <div class="rate-item" v-for="(item, index) in ratingList" :key="index">
      <div class="question-container">
        <span class="question-index">
          {{ index + 1 }}/
        </span>
        <span class="question-title">
          {{ item.question.title }}
        </span>
      </div>
      <div class="question-container answer" v-if="showAnswer && item.question.type!=='video' && item.question.type!=='portfolio'">
        <span class="question-label">{{ $t('hm.label.answerLabel') }}</span>
        <template v-if="item.question.type==='checkbox'">
          <div class="question-context checkbox">
            <span
              class="question-title checkbox checkbox"
              v-for="(answer, index) in item.value"
              :key="index">
              {{ answer }}
            </span>
          </div>
        </template>
        <template v-else>
            <span class="question-title">
              {{ item.value }}
            </span>
        </template>
      </div>
      <div class="question-container question-video-container" v-if="showAnswer && item.question.type==='video'">
        <span class="question-label">{{ $t('hm.resume.video') }}</span>
        <div
          class='video-link'
          @click="handelVideoPop(item)"
          target="_blank">
          <img class="video-play-icon" :src="$DjangoStaticUrl('image/video/icon_video.png')" />
        </div>
      </div>
      <div class="question-container question-attachment-container" v-if="showAnswer && item.question.type==='portfolio'">
        <span class="question-label">{{ $t('hm.resume.attachment') }}</span>
        <a
          class="attachment-tag"
          target="_blank"
          :href="item.value"
        >
          {{ $t('hm.btn.download') }}
        </a>
      </div>
      <div class="rete-context" :class="(item.showtips && !item.rate) ? 'show-tips': ''">
        <van-rate
          v-model="item.rate"
          size="28"
          :readonly="readOnly"
          color="#0096cc"
          :count="6"
        />
        <span v-show="item.showtips && !item.rate" class="tips">{{ $t('hm.tips.pleaseRate') }}</span>
      </div>
      <div class="comment-container">
        <el-input
          type="textarea"
          :autosize="textSize"
          resize="none"
          :readonly="readOnly"
          v-model="item.comment"
          class="title">
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  components: {
  },
  props: {
    ratingList: {
      require: true
    },
    readOnly: {
      default: false
    },
    showAnswer: {
      default: false
    }
  },
  data () {
    return {
      textSize: {
        minRows: 3,
        maxRows: 5
      }
    }
  },
  computed: {
  },
  created () {
    _.forEach(this.ratingList, (item) => {
      this.$set(item, 'showtips', false)
    })
  },
  beforeDestroy () {

  },
  methods: {
    verifyRatingList () {
      if (this.ratingList) {
        let result = true
        _.forEach(this.ratingList, function (item) {
          if (!item.rate) {
            item.showtips = true
            result = false
          }
        })
        return result
      } else {
        return false
      }
    },
    handelVideoPop (item) {
      if (!item || !item.question?.title || !item.value?.private_mp4_url) {
        return
      }
      const params = {
        title: item.question.title,
        private_mp4_url: item.value.private_mp4_url
      }
      this.$emit('videoPop', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.rate-container {
  .rate-item {
    background-color: #FFFFFF;
    padding: 20px 10px;
    margin-bottom: 20px;

    .rete-context {
      margin: 10px 0;

      &.show-tips {
        padding-bottom: 25px;
      }

      position: relative;

      .tips {
        color: red;
        position: absolute;
        right: 0;
        bottom: 0;
        margin: 15px 10px 0 0;
      }
    }

    .question-container {
      display: flex;

      .question-index {
        font-size: 20px;
        margin-right: 4px;
      }

      .question-title {
        font-size: 14px;
        word-break: break-word;
      }

      .question-context {
        .question-index {
          font-size: 24px;
        }

        .question-title {
          margin-left: 15px;
          font-size: 16px;
          line-height: 1.25;
        }
      }

      &.answer {
        align-items: flex-start;
        padding: 10px 0;

        .question-label {
          line-height: 1.25;
        }

        .question-context {
          &.checkbox {
            display: flex;
            flex-direction: column;
          }

          .question-title {
            margin-bottom: 15px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        .question-title {
          margin-left: 15px;
          font-size: 16px;
          line-height: 1.25;
        }
      }

      &.question-video-container {
        display: flex;
        align-items: center;
        padding: 10px 0;

        .video-link {
          background-image: url($baseDomain + 'static/image/video/video_bg.png');
          background-size: 100% 100%;
          width: 120px;
          height: 50px;
          margin-left: 15px;
          display: flex;
          align-items: center;
          justify-content: center;

          .video-play-icon {
            height: 36px;
          }
        }
      }

      &.question-attachment-container {
        display: flex;
        align-items: center;
        padding: 10px 0;

        .attachment-tag {
          margin-left: 15px;
          color: #0096cc;
        }

        .attachment-img {
          width: 30px;
          margin-left: 15px;
        }
      }
    }

    .button-container {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      margin-top: 40px;

      .rate-btn {
        border: 1px solid black;
        padding: 3px 5px;
        cursor: pointer;

        &.reject {
          color: #e27676;
          border-color: #e27676;
        }

        &.padding {
          color: #e6a23c;
          border-color: #e6a23c;
        }

        &.approve {
          color: #00a900;
          border-color: #00a900;
        }

        &.disable {
          color: #606266;
          border-color: #606266;
          cursor: not-allowed;
        }
      }
    }
  }

  ::v-deep .van-rate {
    display: flex;
    justify-content: space-between;
  }

  .rating-tips {
    font-size: 12px;
  }
}
</style>
